var _g, _defs;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgInfo4 = function SvgInfo4(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_34_20618)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.7605 5.51172V31.7917C6.7605 33.405 8.0672 34.7117 9.6805 34.7117H20.8985C20.2664 33.3831 19.9005 31.9012 19.9005 30.3317C19.9005 29.8353 19.9488 29.3491 20.0174 28.8717H11.1405V25.9517H20.8985C22.5396 22.5017 26.0471 20.1117 30.1205 20.1117C31.1352 20.1117 32.1149 20.2664 33.0405 20.5423V5.51172H30.1205C30.1205 6.31764 29.4664 6.97172 28.6605 6.97172C27.8546 6.97172 27.2005 6.31764 27.2005 5.51172H24.2805C24.2805 6.31764 23.6264 6.97172 22.8205 6.97172C22.0146 6.97172 21.3605 6.31764 21.3605 5.51172H18.4405C18.4405 6.31764 17.7864 6.97172 16.9805 6.97172C16.1746 6.97172 15.5205 6.31764 15.5205 5.51172H12.6005C12.6005 6.31764 11.9464 6.97172 11.1405 6.97172C10.3346 6.97172 9.6805 6.31764 9.6805 5.51172H6.7605ZM11.1405 12.8117H28.6605V15.7317H11.1405V12.8117ZM11.1405 20.1117H22.8205V23.0317H11.1405V20.1117ZM30.1205 23.0317C26.0894 23.0317 22.8205 26.3007 22.8205 30.3317C22.8205 34.3628 26.0894 37.6317 30.1205 37.6317C34.1516 37.6317 37.4205 34.3628 37.4205 30.3317C37.4205 26.3007 34.1516 23.0317 30.1205 23.0317ZM33.1146 26.9013L35.1564 28.9459L29.3905 34.7117L25.0846 30.4059L27.1264 28.3613L29.3905 30.6226L33.1146 26.9013Z",
    fill: "#00CB82"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_34_20618"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgInfo4, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/info-4.06e284b8.svg";
export { ForwardRef as ReactComponent };